import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseService } from '../core/services/base.service';
import { IResponse } from '../shared/models/app';

@Injectable({
  providedIn: 'root'
})
export class MasterDataService extends BaseService {

  uoms = [];
  uomsList = [];
  orderingPhysicians = [];
  purchaseOrders = [];
  usages = [];
  products = [];
  otherProducts = []; //SB-3698
  manufacturers = []; //SB-3505
  components = [];
  supplies = [];
  productsBySaleUse = {};
  procedures = [];
  dosingTypes = [];
  nuclides = [];
  allNuclides = [];
  patientHeightWeightTypes = [];
  productsAndSuppliesWithUse = [];
  productsAndSuppliesWithUse1: any;

  constructor(protected http: HttpClient) {
    super(http);
  }

  // //removing cache object on first load
  // cacheService.set("vendor", "");
  // cacheService.set(Constants.AppCache.Name.components, "");
  // cacheService.set(Constants.AppCache.Name.procedures, "");
  // cacheService.set(Constants.AppCache.Name.trackingCode, "");
  // cacheService.set(Constants.AppCache.Name.patientClassification, "");
  // cacheService.set(Constants.AppCache.Name.patientClassificationNames, "");
  // cacheService.set(Constants.AppCache.Name.specialityData, "");
  // cacheService.set(Constants.AppCache.Name.doseFactor, "");

  // getFromServer = function (url, params) {
  //   var data = "";
  //   //var retVal = $http.get(url, params)
  //   return retVal;
  // };


  // postFromServer = function (url, params) {
  //   //var retVal = $http.post(url, params)
  //   return retVal;
  // }


  getUomsList() {
    if (this.uomsList.length == 0) {
      const url = this.apiConfig.config+'/api/uom';
      return super.fetch(url).pipe(
        map((response: IResponse) => {
          if (!response.hasError) {
            this.uomsList = response.data
            return this.uomsList;
          }
        })
      );
    } else {
      return of(this.uomsList);
    }
  }

  getUoms() {

    // var retVal = new GenericService(self.uoms);
    // if (this.uoms.length==0) {
    //   retVal = self.getFromServer('/api/uom').then(function(response) {
    //     angular.forEach(response.data,function(uom){
    //       self.uoms[uom.id]=uom.name;
    //     });
    //     return self.uoms;
    //   });
    // }
    // return retVal;

    if (this.uoms.length == 0) {
      const url = this.apiConfig.config+'/api/uom';
      return super.fetch(url).pipe(
        map((response: IResponse) => {
          if (!response.hasError) {
            this.uoms[response.data.id] = response.data.name;
            return this.uoms;
          }
        })
      );
    } else {
      return of(this.uoms);
    }

  }

  getUsages() {
    const url = this.apiConfig.config+'/config/customercatalog';
    return super.post(url, {});
  }

  getProducts(refreshProductFlg = false) {
    if (refreshProductFlg || this.products.length == 0) {
      const url = this.apiConfig.inventory + '/api/product/search?type=0';
      return super.fetch(url).pipe(
        map((response: IResponse) => {
          if (!response.hasError) {
            this.products = response.data;
            return this.products;
          }
        })
      );
    } else {
      return of(this.products);
    }

  }
  
  //SB-3698 - For saline products
  getOtherProducts() {
    // var retVal = new GenericService(this.otherProducts);
    // if (this.otherProducts.length == 0) {
    //   retVal = this.getFromServer('/api/otherproduct/getAll', {}).then(function (response) {
    //     this.otherProducts = response.data;
    //     return this.otherProducts;
    //   });
    // }
    // return retVal;

    if (this.otherProducts.length == 0) {
      const url = this.apiConfig.hp + '/api/otherproduct/getAll';
      return super.fetch(url).pipe(
        map((response: IResponse) => {
          if (!response.hasError) {
            this.otherProducts = response.data;
            return this.otherProducts;
          }
        })
      );
    } else {
      return of(this.otherProducts);
    }


  }
  //SB-3698

  //SB-3505
  getManufacturers() {
    // var retVal = new GenericService(this.manufacturers);
    // if (this.manufacturers.length == 0) {
    //   retVal = this.getFromServer('/api/manufacturer/getAll', {}).then(function (response) {
    //     this.manufacturers = response.data;
    //     return this.manufacturers;
    //   });
    // }
    // return retVal;

    if (this.manufacturers.length == 0) {
      const url = this.apiConfig.hp + '/api/manufacturer/getAll';
      return super.fetch(url).pipe(
        map((response: IResponse) => {
          if (!response.hasError) {
            this.manufacturers = response.data;
            return this.manufacturers;
          }
        })
      );
    } else {
      return of(this.manufacturers);
    }

  }
  //SB-3505
  getSupplies() {
    // var retVal = new GenericService(this.supplies);
    // if (this.supplies.length == 0) {
    //   retVal = this.getFromServer('/api/product/search?type=1%252C2%252C3', {}).then(function (response) {
    //     this.supplies = response.data;
    //     return this.supplies;
    //   });
    // }
    // return retVal;

    if (this.supplies.length == 0) {
      const url = this.apiConfig.hp  + '/api/product/search?type=1%252C2%252C3';
      return super.fetch(url, {}).pipe(
        map((response: IResponse) => {
          if (!response.hasError) {
            this.supplies = response.data;
            return this.supplies;
          }
        })
      );
    } else {
      return of(this.supplies);
    }

  }
  getPurchaseOrders() {
    // var retVal = new GenericService(this.purchaseOrders);
    // if (this.purchaseOrders.length == 0) {
    //   retVal = this.postFromServer('/config/purchaseorders', {}).then(function (response) {
    //     if (response.data) {
    //       response.data.forEach(function (purchaseOrder) {
    //         purchaseOrder.id = purchaseOrder.customerPurchaseOrderNum;
    //         purchaseOrder.purchaseOrderId = purchaseOrder.purchaseOrderName;
    //         purchaseOrder.endDate = new Date(purchaseOrder.endDate);
    //         this.purchaseOrders.push(purchaseOrder);
    //       });
    //     }
    //     return this.purchaseOrders;
    //   } function (error) {
    //     return error;
    //   });
    // }
    // return retVal;

    if (this.purchaseOrders.length == 0) {
      const url = this.apiConfig.config+'' + '/config/purchaseorders';
      return super.post(url, {}).pipe(
        map((response: IResponse) => {
          if (!response.hasError) {
            response.data.id = response.data.customerPurchaseOrderNum;
            response.data.purchaseOrderId = response.data.purchaseOrderName;
            response.data.endDate = new Date(response.data.endDate);
            this.purchaseOrders.push(response.data);
            return this.purchaseOrders;
          }
        })
      );
    } else {
      return of(this.purchaseOrders);
    }

  }
  getOrderingPhysicians() {
    // var retVal = new GenericService(this.orderingPhysicians);
    // if (this.orderingPhysicians.length == 0) {
    //   retVal = this.postFromServer('/config/orderingphysicians', {}).then(function (response) {
    // response.data.forEach(function (physician) {
    //   physician.fullName = physician.lastName + " " + physician.firstName;
    //   physician.id = physician.orderingPhysicianNum;
    //   this.orderingPhysicians.push(physician);
    // });

    //     return this.orderingPhysicians;
    //   } function (error) {
    //     return error;
    //   });
    // }
    // return retVal;

    if (this.orderingPhysicians.length == 0) {
      const url = this.apiConfig.config+'' + '/config/orderingphysicians';
      let test: any = [];
      return super.post(url, {}).pipe(
        map((response: IResponse) => {
          if(response && response.data){
            response.data.forEach( (physician)=> {
              physician.fullName = physician.lastName + " " + physician.firstName;
              physician.id = physician.orderingPhysicianNum;
              //this.orderingPhysicians.push(physician);
              test.push(physician);
            });
          }
          return test;
        })
      );
    } else {
      return of(this.orderingPhysicians);
    }


  }
  getDosingTypes() {
    // var retVal = new GenericService(this.dosingTypes);
    // if (this.dosingTypes.length == 0) {
    //   retVal = this.getFromServer('/config/types/search', { params: { group: 'dosing' } }).then(function (response) {
    //     this.dosingTypes = response.data;
    //     return this.dosingTypes;
    //   });
    // }
    // return retVal;

    if (this.dosingTypes.length == 0) {
      const url = this.apiConfig.config+'' + '/config/types/search';
      return super.fetch(url, { params: { group: 'dosing' } }).pipe(
        map((response: IResponse) => {
          if (!response.hasError) {
            this.dosingTypes = response.data;
            return this.dosingTypes;
          }
        })
      );
    } else {
      return of(this.dosingTypes);
    }

  }
  getNuclides() {
    // var retVal = new GenericService(this.nuclides);
    // if (this.nuclides.length == 0) {
    //   retVal = this.getFromServer('/api/nuclide').then(function (response) {
    //     this.nuclides = response.data;
    //     return this.nuclides;
    //   } function (response) {
    //     return [];
    //   });
    // }
    // return retVal;

    if (this.nuclides.length == 0) {
      const url = this.apiConfig.hp  + '/api/nuclide';
      return super.fetch(url).pipe(
        map((response: IResponse) => {
          if (!response.hasError) {
            this.nuclides = response.data;
            return this.nuclides;
          }
        })
      );
    } else {
      return of(this.nuclides);
    }

  }

  getProductsAndSuppliesWithUse1() {
    // var retVal = new GenericService(this.productsAndSuppliesWithUse);
    // if (this.productsAndSuppliesWithUse.length == 0) {
    //   retVal = this.getFromServer('/api/products/all').then(function (response) {
    //     this.productsAndSuppliesWithUse = response.data;
    //     return this.productsAndSuppliesWithUse;
    //   });
    // }
    // return retVal;

    if (this.productsAndSuppliesWithUse.length == 0) {
      const url = this.apiConfig.inventory + '/api/products/all';
      return super.fetch(url).pipe(
        map((response: IResponse) => {
          if (!response.hasError) {
            this.productsAndSuppliesWithUse1 = response.data;
            return this.productsAndSuppliesWithUse1;
          }
        })
      );
    } else {
      return of(this.productsAndSuppliesWithUse);
    }

  }
  getPatientHeightWeightTypes() {
    // var retVal = new GenericService(this.patientHeightWeightTypes);
    // if (this.patientHeightWeightTypes.length == 0) {
    //   retVal = this.getFromServer('/config/types/search', { params: { group: 'patient' } }).then(function (response) {
    //     this.patientHeightWeightTypes = response.data;
    //     return this.patientHeightWeightTypes;
    //   });
    // }
    // return retVal;

    if (this.patientHeightWeightTypes.length == 0) {
      const url = this.apiConfig.hp+ '/config/types/search';
      return super.fetch(url, { params: { group: 'patient' } }).pipe(
        map((response: IResponse) => {
          if (!response.hasError) {
            this.patientHeightWeightTypes = response.data;
            return this.patientHeightWeightTypes;
          }
        })
      );
    } else {
      return of(this.patientHeightWeightTypes);
    }

  }
  getProductsAndSuppliesWithUse() {
    // var retVal = new GenericService(this.productsAndSuppliesWithUse);
    // if (this.productsAndSuppliesWithUse.length == 0) {
    //   retVal = this.getFromServer('/api/products/all').then(function (response) {
    //     this.productsAndSuppliesWithUse = response.data;
    //     return this.productsAndSuppliesWithUse;
    //   });
    // }
    // return retVal;

    if (this.productsAndSuppliesWithUse.length == 0) {
      const url = this.apiConfig.hp+ '/api/products/all';
      return super.fetch(url).pipe(
        map((response: IResponse) => {
          if (!response.hasError) {
            this.productsAndSuppliesWithUse = response.data;
            return this.productsAndSuppliesWithUse;
          }
        })
      );
    } else {
      return of(this.productsAndSuppliesWithUse);
    }

  }
  getPeriodTypes() {
    // var retVal = $http.get('/api/periodtype', {}).then(function (response) {
    //   return response.data;
    // });
    // return retVal;

    const url = this.apiConfig.hp+ '/api/periodtype';
    return super.fetch(url).pipe(
      map((response: IResponse) => {
        if (!response.hasError) {
          return response.data.data;
        }
      })
    );
  }
  refreshCache() {
    this.orderingPhysicians = [];
    //				this.purchaseOrders = [];
    //				this.usages =[];
    //				this.products=[];
    //				this.supplies=[];
    this.getOrderingPhysicians();
    //				this.getPurchaseOrders();
    //				this.getUsages();
    //				this.getProducts();
    //				this.getSupplies();
  }
  getSites() {
    // var retVal = $http.get('api/site', { params: { type: 1 } }).then(function (response) {
    //   return response.data;
    // });
    // return retVal;

    const url = this.apiConfig.hp+ '/api/site';
    return super.fetch(url, { params: { type: 1 } }).pipe(
      map((response: IResponse) => {
        if (!response.hasError) {
          return response.data.data;
        }
      })
    );
  }
  getRoutes() {
    // var retVal = $http.get('api/route', { params: { type: 2 } }).then(function (response) {
    //   return response.data;
    // });
    // return retVal;
    const url = this.apiConfig.hp+ '/api/route';
    return super.fetch(url, { params: { type: 2 } }).pipe(
      map((response: IResponse) => {
        if (!response.hasError) {
          return response.data.data;
        }
      })
    );
  }
  getDoseFactors() {
    // var retVal = $http.get('/config/doseFactors', {}).then(function (response) {
    //   return response.data;
    // });
    // return retVal;

    const url = this.apiConfig.config+'' + '/config/doseFactors';
    return super.fetch(url, {}).pipe(
      map((response: IResponse) => {
        if (!response.hasError) {
          return response.data;
        }
      })
    );

  }
  refreshPurchaseOrders() {
    // this.purchaseOrders = [];
    // return this.postFromServer('/config/purchaseorders', {}).then(function (response) {
    //   if (response.data) {
    //     response.data.forEach(function (purchaseOrder) {
    //       purchaseOrder.id = purchaseOrder.customerPurchaseOrderNum;
    //       purchaseOrder.purchaseOrderId = purchaseOrder.purchaseOrderName;
    //       purchaseOrder.endDate = new Date(purchaseOrder.endDate);
    //       this.purchaseOrders.push(purchaseOrder);
    //     });
    //   }
    //   return this.purchaseOrders;
    // } function (error) {
    //   return error;
    // });
    this.purchaseOrders = [];
    const url = this.apiConfig.config+'' + '/config/purchaseorders';
    return super.post(url, {}).pipe(
      map((response: IResponse) => {
        if (!response.hasError) {
          response.data.data.forEach(function (purchaseOrder) {
            purchaseOrder.id = purchaseOrder.customerPurchaseOrderNum;
            purchaseOrder.purchaseOrderId = purchaseOrder.purchaseOrderName;
            purchaseOrder.endDate = new Date(purchaseOrder.endDate);
            this.purchaseOrders.push(purchaseOrder);
          });
        }
        return this.purchaseOrders;
      })
    );

  }
  getBinaryReport(url) {
    // return $http.get(url, { responseType: 'arraybuffer' }).success(function (data, status, headers, config) {
    //   return data;
    // });

    //const url = this.apiConfig.hp+ '/config/doseFactors';
    return super.fetch(url, { responseType: 'arraybuffer' }).pipe(
      map((response: IResponse) => {
        if (!response.hasError) {
          return response.data.data;
        }
      })
    );

  }
  flushData() {
    // this.products = [];
    // this.supplies = [];
    // this.purchaseOrders = [];
    // this.usages = [];
    // //window.localStorage['preferences'] = "";
    // //cacheService.set("preferences","");
    // cacheService.set("vendor", "");
    // cacheService.set(Constants.AppCache.Name.components, "");
    // cacheService.set(Constants.AppCache.Name.procedures, "");
    // cacheService.set(Constants.AppCache.Name.trackingCode, "");
    // cacheService.set(Constants.AppCache.Name.patientClassification, "");
    // cacheService.set(Constants.AppCache.Name.patientClassificationNames, "");
    // cacheService.set(Constants.AppCache.Name.specialityData, "");
    // cacheService.set(Constants.AppCache.Name.doseFactor, "");
  }

  getSpecialProducts() {
    // return $http.post('/config/specialproducts', {}).then(function (response) {
    //   return response;
    // })

    const url = this.apiConfig.hp+ '/config/specialproducts';
    return super.fetch(url, {}).pipe(
      map((response: IResponse) => {
        if (!response.hasError) {
          return response.data;
        }
      })
    );

  }

  getBackground(uomNum, date, taskType) {
    return super.fetch(this.apiConfig.hp + '/api/background/search', { params: { uomNum: uomNum, taskType: taskType, date: date } })
  }








}
